module.exports = __webpack_public_path__ + "static/media/shell32_170.c1fc0be2.ico";